export default __webpack_public_path__ + "static/media/1781.fb81836f.png";